import placeholderImage from 'assets/img/covers/placeholder.jpg';
import { uploadMedia } from 'utils/mediaResourceUtils';

export const isCustomArtist = (artist) =>
  artist?.uid?.startsWith('custom-artist') || artist?.retailer_uid === null;

export const getArtistImage = (artist) =>
  artist?.image_url ||
  artist?.picture ||
  artist?.picture_url ||
  artist?.avatar_url ||
  artist?.connected_user?.picture ||
  placeholderImage;

export const getArtistName = (artist) =>
  artist?.name || artist?.connected_user?.name || artist?.connected_user?.email || '';

export const getArtistDescription = (artist) => artist?.description || artist?.role || '';

export const filterArtistByNameOrEmail = (item, query) => {
  const name = (
    item.name ||
    item.connected_user?.name ||
    item.connected_user?.email ||
    ''
  ).toLowerCase();
  return name.includes(query.toLowerCase());
};

export const getArtistKey = (artist) => artist.uid;

const getPictureIdFromUrl = (url) => {
  const match = url?.match(/\/v\d+\/(.+?)(?:\.[^/.?#]+)?(?:[?#].*)?$/);
  return match?.[1];
};

export const buildArtistFromForm = (formValues) => {
  const { existingArtist, picture, name, description, uid } = formValues;
  const pictureItem = picture[0];
  const isFile = pictureItem instanceof File || Boolean(pictureItem?.size);
  const pictureFile = isFile ? pictureItem : existingArtist?.pictureFile || null;
  const previewSource = isFile
    ? URL.createObjectURL(pictureItem)
    : typeof pictureItem === 'string'
      ? pictureItem
      : getArtistImage(existingArtist);

  return {
    uid: uid || `custom-artist-${crypto.randomUUID()}`,
    name: name.trim(),
    description: description?.trim() || '',
    retailer_uid: existingArtist?.retailer_uid ?? null,
    pictureFile,
    picture: previewSource,
    image_url: previewSource,
    picture_id: isFile ? null : existingArtist?.picture_id || getPictureIdFromUrl(previewSource),
  };
};

export const getArtistFormInitialValues = (item) => {
  const existingImage = item ? getArtistImage(item) : null;

  return {
    uid: item?.uid || null,
    name: getArtistName(item),
    description: getArtistDescription(item),
    picture: existingImage && existingImage !== placeholderImage ? [existingImage] : [],
    existingArtist: item,
  };
};

export const canSaveArtistForm = (values) => Boolean(values.name?.trim() && values.picture?.length);

export const buildCustomArtistPayload = async (artist) => {
  if (artist.pictureFile) {
    const uploadedPicture = await uploadMedia([artist.pictureFile]);
    if (!uploadedPicture?.public_id) throw new Error('Image upload failed');
    return {
      name: artist.name,
      picture_id: uploadedPicture.public_id,
      ...(artist.description ? { description: artist.description } : {}),
    };
  }

  if (artist.picture_id) {
    return {
      name: artist.name,
      picture_id: artist.picture_id,
      ...(artist.description ? { description: artist.description } : {}),
    };
  }

  const pictureId = getPictureIdFromUrl(artist.picture || artist.image_url);
  if (pictureId) {
    return {
      name: artist.name,
      picture_id: pictureId,
      ...(artist.description ? { description: artist.description } : {}),
    };
  }

  throw new Error('Picture required');
};
